(function () {
  function setBoolAttr(el, name, on) {
    if (!el) return;
    if (on) el.setAttribute(name, "");
    else el.removeAttribute(name);
  }

  function onChipClick(e) {
    const chipBtn = e.target.closest(".product-chips-options__item button");
    if (!chipBtn) return;

    const card = chipBtn.closest(".product-item");
    if (!card) return;

    const variantId = chipBtn.getAttribute("data-variant-id");
    const priceText = chipBtn.getAttribute("data-variant-price");
    const url = chipBtn.getAttribute("data-variant-url");
    const available = chipBtn.getAttribute("data-variant-available") === "true";

    // 1) Update hidden variant input (so quick-add adds the RIGHT variant)
    const variantInput = card.querySelector('input[data-pa-variant-input][name="id"]');
    if (variantInput && variantId) variantInput.value = variantId;

    // 2) Update button state + text + price
    const btn = card.querySelector("[data-pa-atc]");
    if (btn) {
      const atcTextEl = btn.querySelector("[data-pa-atc-text]") || btn.querySelector(".prod-atc");
      const priceEl = btn.querySelector("[data-pa-atc-price]") || btn.querySelector(".prod-price");

      const soldText = btn.getAttribute("data-pa-soldout-text") || "Out of stock";
      const addText = btn.getAttribute("data-pa-add-text") || "Add to Bag";

      if (available) {
        btn.classList.remove("is-sold-out");
        btn.disabled = false;
        btn.removeAttribute("aria-disabled");

        if (atcTextEl) atcTextEl.textContent = addText + " - ";
        if (priceEl) {
          priceEl.textContent = priceText || priceEl.textContent;
          priceEl.removeAttribute("hidden");
        }
      } else {
        btn.classList.add("is-sold-out");
        btn.disabled = true;
        btn.setAttribute("aria-disabled", "true");

        if (atcTextEl) atcTextEl.textContent = soldText;
        if (priceEl) setBoolAttr(priceEl, "hidden", true);
      }

      // Keep data-product-id correct if your theme reads it
      if (variantId) btn.setAttribute("data-product-id", variantId);
    }

    // 3) Toggle sold out badge on the card
    const soldBadge = card.querySelector("[data-pa-soldout-badge]");
    if (soldBadge) {
      if (available) soldBadge.setAttribute("hidden", "");
      else soldBadge.removeAttribute("hidden");
    }

    // 4) Update links to selected variant (optional but nice)
    if (url) {
      const link1 = card.querySelector(".product-item__image-link");
      const link2 = card.querySelector(".product-item__product-title a");
      if (link1) link1.href = url;
      if (link2) link2.href = url;
    }
  }

  document.addEventListener("click", onChipClick);
})();